import Component from '@glimmer/component';
import RouteTemplate from 'ember-route-template';
import BannerComponent from '../../components/layout/banner/main';
import LiveNewsTicker from '../../components/layout/live-news-ticker';
import EsportsNewsComponent from '../../components/layout/news/esports-news';
import LiveMatchPlayer from '../../components/esports/tournament/live-match-player';
import RecentMatchPlayer from '../../components/esports/tournament/recent-match-player';
import UpcomingMatches from '../../components/esports/tournament/upcoming-matches';
import TournamentStandings from '../../components/esports/tournament/standings';
import PlayDaysOverview from '../../components/esports/tournament/play-days-overview';
import TournamentSidebar from '../../components/esports/tournament/sidebar';
import TournamentBracket from '../../components/esports/tournament/bracket';
import EsportsMatchResultsBanner from '../../components/layout/banner/esports-match-results';
import { pageTitle } from 'ember-page-title';

class EsportsTournamentComponent extends Component {
  get upcomingMatches() {
    return this.args.model.matches.filter((match) => {
      return match.isLive === false && match.isFinal === false;
    });
  }

  get liveMatch() {
    return this.args.model.isLive;
  }

  get recentMatches() {
    return this.args.model.matches.filter((match) => {
      return match.isFinal === true;
    });
  }

  get recentMatch() {
    return this.recentMatches[0];
  }

  get sortedTeams() {
    if (!this.args.model.teams) {
      return [];
    }
    return this.args.model.teams.slice().sort((a, b) => {
      // Sort by wins (descending), then by losses (ascending)
      if (b.wins !== a.wins) {
        return b.wins - a.wins;
      }
      return a.losses - b.losses;
    });
  }

  <template>
    {{pageTitle @model.title}}
    <BannerComponent @theme='e-sport' @title={{@model.title}} />
    <LiveNewsTicker />
    <EsportsMatchResultsBanner />
    <div class='layout-content-1 layout-item grid-limit no-padding-bottom'>
      <div class='layout-body layout-item gutter-big'>
        {{#if this.liveMatch}}
          <LiveMatchPlayer @match={{@model}} />
        {{else if this.recentMatches}}
          <RecentMatchPlayer @match={{this.recentMatch}} />
        {{/if}}
        {{#if @model.isFinal}}
          <PlayDaysOverview @tournament={{@model}} />
        {{else}}
          <UpcomingMatches @matches={{this.upcomingMatches}} />
        {{/if}}
        <TournamentStandings @tournament={{@model}} @teams={{this.sortedTeams}} />
      </div>
      <TournamentSidebar @tournament={{@model}} />
    </div>
  </template>
}
export default RouteTemplate(EsportsTournamentComponent);
